export const MODULE_NAME = 'RecentAuthorizations'
export const MMN = 'Meritage Medical Network'
export const FCMG = 'First Choice Medical Group'
export const ADMIN_ACCESS = '1'
export const REGULAR_ACCESS = '2'
export const HEALTH_PLAN_ACCESS = '6'
